import {
  Button,
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '~/components/ui'
import type { GeographyLayerFilterOption } from '~/lib/geography-layer-filter'

const NO_GEOGRAPHY_LAYER_VALUE = '__all_geography_layers__'

type MapGeographyLayerFilterProps = {
  options: GeographyLayerFilterOption[]
  value: GeographyLayerFilterOption | null
  updateFilter: (value: GeographyLayerFilterOption | null) => void
}

export default function MapGeographyLayerFilter({
  options,
  value,
  updateFilter,
}: MapGeographyLayerFilterProps) {
  if (options.length === 0) return null

  return (
    <div className="space-y-2">
      <p className="text-sm">
        Layer
        {value && (
          <Button
            variant="link"
            size="none"
            className="ml-2"
            onClick={() => updateFilter(null)}>
            (reset)
          </Button>
        )}
      </p>
      <Select
        value={value?.id ?? NO_GEOGRAPHY_LAYER_VALUE}
        onValueChange={(id) => {
          updateFilter(
            id === NO_GEOGRAPHY_LAYER_VALUE
              ? null
              : (options.find((option) => option.id === id) ?? null)
          )
        }}>
        <SelectTrigger>
          <SelectValue placeholder="All geography layers" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value={NO_GEOGRAPHY_LAYER_VALUE}>
            All geography layers
          </SelectItem>
          {options.map((option) => (
            <SelectItem key={option.id} value={option.id}>
              {option.label}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  )
}
